import { getMacroProtocolMacros as getMacroProtocolMacrosShared, maybeAthleteBirthDateToAge, } from "@notemeal/shared-utils-macro-protocol";
export const getMacroProtocolMacros = (macroProtocol, athleteBirthdate) => getMacroProtocolMacrosShared({
    ...macroProtocol,
    anthropometrySnapshot: { ...macroProtocol.anthropometrySnapshot, age: maybeAthleteBirthDateToAge(athleteBirthdate) },
});
export const MINIMUM_AGE = 13;
export const invalidAge = (birthdate) => {
    const maybeAge = maybeAthleteBirthDateToAge(birthdate);
    return !maybeAge || maybeAge < MINIMUM_AGE;
};
export const requiredAnthropometryFormFieldsForMacroProtocol = (macroProtocol) => {
    if (!macroProtocol.calorieBudget?.rmrMethod) {
        return [];
    }
    switch (macroProtocol.calorieBudget.rmrMethod) {
        case "cunningham":
            return ["percentBodyFat", "weight"];
        case "harrisBenedict":
            return ["height", "weight"];
        case "mifflin":
            return ["height", "weight"];
        case "average":
            return ["percentBodyFat", "height", "weight"];
        case "%future added value":
            return [];
        default:
            return [];
    }
};
export const formatKcalOffset = (kcalOffset) => {
    if (kcalOffset > 0) {
        return `+${kcalOffset} kcal`;
    }
    else {
        return `${kcalOffset} kcal`;
    }
};
//# sourceMappingURL=utils.js.map